/**
 * Utility functions for cryptographic operations
 */
export class CryptoUtils {
	/**
	 * Hashes an email address using SHA-256 algorithm for analytics tracking
	 * 
	 * @param email The email address to hash
	 * @returns A promise that resolves to the hashed email in hex format
	 */
	static async hashEmail(email: string): Promise<string> {
	  // Handle empty or null input gracefully
	  if (!email) {
		return '';
	  }
	  
	  // Normalize the email:
	  // 1. Remove leading and trailing whitespaces
	  // 2. Convert to lowercase
	  const normalizedEmail = email.trim().toLowerCase();
	  
	  return this.hashSha256(normalizedEmail);
	}
  
	/**
	 * Hashes a string using SHA-256 algorithm
	 * 
	 * @param text The text to hash
	 * @returns A promise that resolves to the hashed string in hex format
	 */
	static async hashSha256(text: string): Promise<string> {
	  if (!text) {
		return '';
	  }
	  
	  // Convert the string to a Uint8Array
	  const encoder = new TextEncoder();
	  const data = encoder.encode(text);
	  
	  // Hash the data using SHA-256
	  const hashBuffer = await crypto.subtle.digest('SHA-256', data);
	  
	  // Convert the hash to a hex string
	  const hashArray = Array.from(new Uint8Array(hashBuffer));
	  const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
	  
	  return hashHex;
	}
  }